import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Salary from "./Salary";
import { Header } from '../Header';
import { Footer } from '../Footer';
import Document from "../Accountings/Document";

export default class Salaries extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: 'salary',
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true,
            systemModuleId: 33,
            moduleAccessStatus: 1,
            menuId: 45
        };

        this.state.filters = {
            personId: this.isNull(props.PersonId) ? this.getDefaultGuid() : props.PersonId,
            status: 0,
            personName: ''
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Salary Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Salary Caller={this} /> });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست تنخواه ها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} تنخواه یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em>
                                                <span>ثبت تنخواه جدید</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder={"شماره تنخواه"} className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.personName} onChange={e => this.state.filters.personName = e.target.value} placeholder="نام تنخواه گردان" className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                            <option value="0">همه وضعیتها</option>
                                            <option value="1">پیش نویس</option>
                                            <option value="2">سند صادر شده</option>
                                        </select>
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ تنخواهی یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">شماره سند</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">نام تنخواه گردان</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">ازتاریخ</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">تا تاریخ</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">مبلغ کل</span></div>
                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.number}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col">
                                            {record.documentNumber > 0 && <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.showDocument(record.documentId)}>{record.documentNumber}</a>
                                            </span>}
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.personName}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.fromDateString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.toDateString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.statusString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(record.total)}</span>
                                        </div>
                                        <div className="nk-tb-col text-end">
                                            <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <em className="icon ni ni-cross-fill-c"></em>
                                            </a>
                                            <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <em className="icon ni ni-pen"></em>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                    <Footer />,
                ] :
                    this.state.inline ? this.renderView() :
                        [
                            <Header data={this.state.data} />,
                            <div className="nk-content ">
                                <div className="container-fluid">
                                    <div className="nk-content-inner">
                                        {this.renderForm()}
                                    </div>
                                </div>
                            </div>,
                            <Footer />,
                        ]
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}